import React from 'react';

import { lensTokens } from '~/configs/unifiedAnalyticsTheme';

import { Paper, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { type ValueKind, changeText, compactText } from './format';
import { change } from './model';

export default function AgentHubTile({
  label,
  value,
  kind,
  previous,
  note,
}: {
  label: string;
  value: number | null;
  kind: ValueKind;
  previous?: number | null;
  note?: string;
}) {
  const theme = useTheme();
  const tokens = lensTokens(theme);
  const delta = previous === undefined ? null : change(value, previous);
  return (
    <Paper variant="outlined" sx={{ p: 1.5, minWidth: 0, bgcolor: tokens.surface }}>
      <Typography variant="caption" color="text.secondary">
        {label}
      </Typography>
      <Typography
        variant="h6"
        sx={{
          fontSize: { xs: 19, sm: 22 },
          fontVariantNumeric: 'tabular-nums',
          color: tokens.accent,
          overflowWrap: 'anywhere',
        }}
      >
        {compactText(value, kind)}
      </Typography>
      <Typography
        variant="caption"
        sx={{
          display: 'block',
          minHeight: 18,
          color: delta === null ? 'text.secondary' : delta < 0 ? theme.palette.error.main : theme.palette.success.main,
        }}
      >
        {delta === null ? (note ?? '') : `${changeText(delta)} vs prior`}
      </Typography>
    </Paper>
  );
}
